/**
 * Remembers scroll position per page and restores it when the shopper returns
 * with browser history or the product-page back button. Runs independently of
 * the browser's bfcache, which third-party scripts on this theme can evict.
 */
(function () {
  var RESTORE_DELAYS = [0, 50, 150, 300, 600, 1000, 1500, 2500, 4000];
  var CANCEL_EVENTS = ['wheel', 'touchstart', 'keydown'];
  var STORAGE_PREFIX = 'scrollPosition:';
  var RESTORE_PREFIX = 'scrollPositionRestore:';
  var restoreWasCancelled = false;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function storageKey() {
    return STORAGE_PREFIX + pageKey(window.location);
  }

  function restoreKey() {
    return RESTORE_PREFIX + pageKey(window.location);
  }

  function pageKey(locationLike) {
    return locationLike.pathname + locationLike.search;
  }

  function isBackForwardNavigation() {
    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
      var entries = window.performance.getEntriesByType('navigation');
      if (entries.length) return entries[0].type === 'back_forward';
    }
    if (window.performance && window.performance.navigation) {
      return window.performance.navigation.type === 2;
    }
    return false;
  }

  function saveScrollPosition() {
    try {
      sessionStorage.setItem(storageKey(), JSON.stringify({ y: Math.round(window.scrollY) }));
    } catch (error) {
    }
  }

  function restoreScrollPosition() {
    if (restoreWasCancelled) return;

    var storedRaw;
    try {
      storedRaw = sessionStorage.getItem(storageKey());
    } catch (error) {
      return;
    }
    if (storedRaw === null) return;

    var stored;
    try {
      stored = JSON.parse(storedRaw);
    } catch (e) {
      stored = { y: parseInt(storedRaw, 10) };
    }

    var targetY = typeof stored.y === 'number' ? stored.y : parseInt(stored.y, 10);
    if (isNaN(targetY) || targetY < 0) targetY = 0;

    var timeoutIds = RESTORE_DELAYS.map(function (delay) {
      return window.setTimeout(function () {
        window.scrollTo(0, targetY);
      }, delay);
    });

    function cancelRestore() {
      restoreWasCancelled = true;
      timeoutIds.forEach(window.clearTimeout);
      CANCEL_EVENTS.forEach(function (type) {
        window.removeEventListener(type, cancelRestore);
      });
    }

    CANCEL_EVENTS.forEach(function (type) {
      window.addEventListener(type, cancelRestore, { passive: true });
    });
  }

  var saveTimeoutId;
  window.addEventListener(
    'scroll',
    function () {
      window.clearTimeout(saveTimeoutId);
      saveTimeoutId = window.setTimeout(saveScrollPosition, 200);
    },
    { passive: true }
  );

  window.addEventListener('pagehide', saveScrollPosition);
  window.addEventListener('beforeunload', saveScrollPosition);

  function shouldRestoreAfterScriptedBack() {
    try {
      if (sessionStorage.getItem(restoreKey()) !== '1') return false;
      sessionStorage.removeItem(restoreKey());
      restoreWasCancelled = false;
      return true;
    } catch (e) {
      return false;
    }
  }

  var restoreRequested = isBackForwardNavigation() || shouldRestoreAfterScriptedBack();
  if (restoreRequested) {
    restoreWasCancelled = false;
    restoreScrollPosition();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (restoreRequested) restoreScrollPosition();
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted || shouldRestoreAfterScriptedBack()) {
      restoreWasCancelled = false;
      restoreRequested = true;
      restoreScrollPosition();
    }
  });

  window.addEventListener('load', function () {
    if (restoreRequested) restoreScrollPosition();
  });

  // Capture early so the previous page's exact scroll offset is stored before
  // a link, form, or third-party script starts navigating.
  function captureNavigationStart(event) {
    try {
      var anchor = event.target.closest && event.target.closest('a');
      if (!anchor) return;
      var href = anchor.getAttribute('href');
      if (!href) return;

      var url = new URL(href, location.href);
      if (url.origin !== location.origin || url.pathname === location.pathname && url.search === location.search) return;

      restoreWasCancelled = false;
      saveScrollPosition();
    } catch (e) {
      // swallow errors
    }
  }

  document.addEventListener('pointerdown', captureNavigationStart, true);
  document.addEventListener('touchstart', captureNavigationStart, true);
  document.addEventListener('click', captureNavigationStart, true);
})();
